import { SUGGESTION_MODE_OPTION } from '../Models/Models';
import WebcamCustom from './WebcamCustom';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param useState: photoPickerFile: model for file (rquired)
 * @param useState: setPhotoPickerFile: event for ser model by file (requiered)
 * @param useState: setActiveStep: change step
 * @param useState startup - Indicates that the camera should be started.
 * @param useState setStartup - Assigns a boolean value to start or stop the camera.
 * @param event handleCancelStream - Event to cancel the camera video stream. If the event is not provided, it will, by default, remove the data from the photoPickerFile model.
 * @param boolean validateFace: default value is false, must be set to true if face validation is required
 * @param boolean showModalSuggestion - To display the suggestions modal
 * @param useState setIsCameraSelected - Event to assign a boolean value indicating whether the camera has already been selected or not.
 * @param setDisplayModal - Required when used inside a modal
 * @param titleWebcam - Title displayed when the camera video stream is active
 * @param titlePreviewWebcam - Title shown after a photo is taken, along with informational text in the preview of the captured image
 *
 */
const FacePhoto = (
    {
        photoPickerFile,
        setPhotoPickerFile,
        setActiveStep,
        startup,
        setStartup,
        handleCancelStream,
        validateFace = true,
        showModalSuggestion = true,
        setIsCameraSelected,
        setDisplayModal = null, // Required when used inside a modal
        titleWebcam = '', // Title displayed when the camera video stream is active
        titlePreviewWebcam = '', // Title shown after a photo is taken, along with informational text in the preview of the captured image
    }
) => {

    const { t } = useTranslation();
    const [reopenSuggestionShow, setReopenSuggestionShow] = useState(showModalSuggestion);

    return (
        <>

            {photoPickerFile.selfieSrc == null &&
                <>
                    {titleWebcam != '' &&
                        <p className="pb-3 fs-18-to-14 ibl-font-w-600 font-color-general-950 text-center">{t(titleWebcam)}</p>
                    }
                </>

            }

            <WebcamCustom
                photoPickerFile={photoPickerFile}
                setPhotoPickerFile={setPhotoPickerFile}
                setActiveStep={setActiveStep}
                titlePreviewWebcam={titlePreviewWebcam}
                startup={startup}
                setStartup={setStartup}
                reopenSuggestionShow={reopenSuggestionShow}
                setReopenSuggestionShow={setReopenSuggestionShow}
                typeSuggestions={SUGGESTION_MODE_OPTION.FACE_VALIDATION_SELFIE}
                handleCancelStream={handleCancelStream}
                validateFace={validateFace}
                setIsCameraSelected={setIsCameraSelected}
                setDisplayModal={setDisplayModal}
            />
        </>
    )

}

export default FacePhoto
